import HttpClientToken from '../../services/HttpClientToken';

import { TipoRecurrenteProps, defaultTipoRecurrente } from '../../interfaces/catalogos/TipoRecurrenteInterface';

export const TipoRecurrentes = () => {

    return new Promise<TipoRecurrenteProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoRecurrente/', token)
            .then( ({ data } : { data : TipoRecurrenteProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoRecurrente = () => {

    return new Promise<TipoRecurrenteProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoRecurrente/ObtenerTipoRecurrentes', token)
            .then( ({ data } : { data : TipoRecurrenteProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoRecurrente = ( params: TipoRecurrenteProps ) => {

    return new Promise<TipoRecurrenteProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoRecurrente/Actualizar', params, token)
            .then( ({ data } : { data : TipoRecurrenteProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoRecurrente } );
            });

        }

    });

}

export const AgregarTipoRecurrente = ( params: TipoRecurrenteProps ) => {

    return new Promise<TipoRecurrenteProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoRecurrente/Agregar', params, token)
            .then( ({ data } : { data : TipoRecurrenteProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoRecurrente } );
            });

        }

    });

}
